import { render, staticRenderFns } from "./NewConsultationFormComponent.vue?vue&type=template&id=426b767b&scoped=true"
import script from "./NewConsultationFormComponent.vue?vue&type=script&lang=ts"
export * from "./NewConsultationFormComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b767b",
  null
  
)

export default component.exports